import { axios } from '@/utils/request'
const api = {
  source: '/finance/masterController',
}

export function getSourceList (parameter) {
  return axios({
    url: api.source ,
    method: 'get',
    params: parameter
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/finance/masterController/listExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
export function getorderExport (parameter) {
  return axios({
    url: '/finance/masterController/orderExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
export function getdownloadFailedDat (parameter) {
  return axios({
    url: '/finance/masterController/downloadFailedData',
    method: 'post',
    data: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getdownloadFailedDataOrder (parameter) {
  return axios({
    url: '/finance/masterController/downloadFailedDataOrder',
    method: 'post',
    data: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function removeSettleList (parameter) {
  return axios({
    url: api.source + '/remove',
    method: 'GET',
    params: parameter
  })
}
export function getEditList (parameter) {
  return axios({
    url: api.source + '/detail',
    method: 'get',
    params: parameter
  })
}
export const sourceExport = api.source + '/export'